/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUserDto } from './GetUserDto';
import {
    GetUserDtoFromJSON,
    GetUserDtoFromJSONTyped,
    GetUserDtoToJSON,
} from './GetUserDto';

/**
 * 
 * @export
 * @interface GetParamsDto
 */
export interface GetParamsDto {
    /**
     * 
     * @type {string}
     * @memberof GetParamsDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetParamsDto
     */
    group: GetParamsDtoGroupEnum;
    /**
     * 
     * @type {string}
     * @memberof GetParamsDto
     */
    name: GetParamsDtoNameEnum;
    /**
     * 
     * @type {string}
     * @memberof GetParamsDto
     */
    type: GetParamsDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetParamsDto
     */
    valueString?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetParamsDto
     */
    valueBoolean?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetParamsDto
     */
    valueDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof GetParamsDto
     */
    valueNumber?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetParamsDto
     */
    isEditable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetParamsDto
     */
    isVisible: boolean;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetParamsDto
     */
    owner?: GetUserDto;
    /**
     * 
     * @type {Date}
     * @memberof GetParamsDto
     */
    ts?: Date;
}


/**
 * @export
 */
export const GetParamsDtoGroupEnum = {
    SYS: 'SYS',
    Reports: 'Reports',
    Invoicing: 'Invoicing'
} as const;
export type GetParamsDtoGroupEnum = typeof GetParamsDtoGroupEnum[keyof typeof GetParamsDtoGroupEnum];

/**
 * @export
 */
export const GetParamsDtoNameEnum = {
    JudgmentsLookbackMonths: 'JudgmentsLookbackMonths',
    TopCompaniesLimit: 'TopCompaniesLimit',
    ReportLastDays: 'ReportLastDays',
    FaceIdentityRetentionDays: 'FaceIdentityRetentionDays',
    AutomaticJudgmentDelayMinutes: 'AutomaticJudgmentDelayMinutes',
    ReferralFreshnessMonths: 'ReferralFreshnessMonths',
    AutomaticJudgmentRequireSignedExternalReferral: 'AutomaticJudgmentRequireSignedExternalReferral',
    WithoutJudgmentDays: 'WithoutJudgmentDays',
    AutoInvoiceMaxApprovalAmount: 'AutoInvoiceMaxApprovalAmount',
    AutoInvoiceDefaultPaymentDays: 'AutoInvoiceDefaultPaymentDays',
    AutoInvoiceErrorEmail: 'AutoInvoiceErrorEmail',
    AutoInvoiceDeadlineDayOfMonth: 'AutoInvoiceDeadlineDayOfMonth',
    SynevoOrderFee: 'SynevoOrderFee'
} as const;
export type GetParamsDtoNameEnum = typeof GetParamsDtoNameEnum[keyof typeof GetParamsDtoNameEnum];

/**
 * @export
 */
export const GetParamsDtoTypeEnum = {
    String: 'String',
    Boolean: 'Boolean',
    Number: 'Number',
    Date: 'Date'
} as const;
export type GetParamsDtoTypeEnum = typeof GetParamsDtoTypeEnum[keyof typeof GetParamsDtoTypeEnum];


/**
 * Check if a given object implements the GetParamsDto interface.
 */
export function instanceOfGetParamsDto(value: object): value is GetParamsDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('group' in value) || value['group'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('isEditable' in value) || value['isEditable'] === undefined) return false;
    if (!('isVisible' in value) || value['isVisible'] === undefined) return false;
    return true;
}

export function GetParamsDtoFromJSON(json: any): GetParamsDto {
    return GetParamsDtoFromJSONTyped(json, false);
}

export function GetParamsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetParamsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'group': json['group'],
        'name': json['name'],
        'type': json['type'],
        'valueString': json['valueString'] == null ? undefined : json['valueString'],
        'valueBoolean': json['valueBoolean'] == null ? undefined : json['valueBoolean'],
        'valueDate': json['valueDate'] == null ? undefined : (new Date(json['valueDate'])),
        'valueNumber': json['valueNumber'] == null ? undefined : json['valueNumber'],
        'isEditable': json['isEditable'],
        'isVisible': json['isVisible'],
        'owner': json['owner'] == null ? undefined : GetUserDtoFromJSON(json['owner']),
        'ts': json['ts'] == null ? undefined : (new Date(json['ts'])),
    };
}

export function GetParamsDtoToJSON(value?: GetParamsDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'group': value['group'],
        'name': value['name'],
        'type': value['type'],
        'valueString': value['valueString'],
        'valueBoolean': value['valueBoolean'],
        'valueDate': value['valueDate'] == null ? undefined : ((value['valueDate']).toISOString()),
        'valueNumber': value['valueNumber'],
        'isEditable': value['isEditable'],
        'isVisible': value['isVisible'],
        'owner': GetUserDtoToJSON(value['owner']),
        'ts': value['ts'] == null ? undefined : ((value['ts']).toISOString()),
    };
}

